import { Extension } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    loomAlign: {
      setLoomAlign: (align: "left" | "center" | "right") => ReturnType;
    };
  }
}

export const LoomAlign = Extension.create({
  name: "loomAlign",

  addGlobalAttributes() {
    return [
      {
        types: ["loom"],
        attributes: {
          align: {
            default: "center",
            parseHTML: (el) => el.getAttribute("data-align") ?? "center",
            renderHTML: (attrs) => ({ "data-align": attrs.align }),
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setLoomAlign:
        (align: "left" | "center" | "right") =>
        ({ chain }) =>
          chain().updateAttributes("loom", { align }).run(),
    };
  },
});
